import type { PaymentFor } from "@/data/model/Enums";
import type { IFulfillmentChangedEvent } from "@/data/model/Events";
import type { IFulfillmentGroup } from "@/data/model/FulfillmentGroup";
import type { IOperatorFulfillment } from "@/data/model/Operator";
import type { ShowRoomPlanEventData } from "@/data/model/Table";
import type { IOperatorSettings } from "@/data/model/User";
import { Signal, TypedSignal } from "@/data/util/Signal";


export type ShowSideMenuEventData = { selectedDate: Date }
export type SideMenuChangedSelectedDateEventData = { selectedDate: Date }

export type ShowOrderAndPayViewEventData = {
    tableId: string;
    billId: string | undefined;
    force?: boolean;
    externalPaymentId?: string;
    transactionId?: string;
    transactionFor?: PaymentFor;
};
export type OpenBillTableSelectedEventData = { tableId: string; billId: string };
export type FulfillmentClickedEventData = {
    fulfillment: IOperatorFulfillment;
    fulfillmentGroup: IFulfillmentGroup | undefined;
};

export const operatorEvents = {
    hideVisibleController: new Signal(),
    hideVisibleVueView: new Signal(),
    showOrderAndPayView: new TypedSignal<ShowOrderAndPayViewEventData>(),

    context: {
        loaded: new Signal(),
        signingOut: new Signal(),
        settingsUpdated: new Signal(),
        settingsChanged: new TypedSignal<IOperatorSettings | undefined>(),
        authenticationChanged: new TypedSignal<boolean>(),
        locationChanged: new Signal(),
    },
    payContext: {
        invalidSelectionsPopupViewed: new Signal(),
        cartTotalDiscountMismatchPopupViewed: new Signal(),
        billTotalDiscountMismatchPopupViewed: new Signal(),
        goBackToPreorderTimeSelectionRequested: new Signal(),
    },
    productionContext: {
        FulfillmentsLoaded: new Signal(),
        FulfillmentAdded: new TypedSignal<IOperatorFulfillment>(),
        FulfillmentChanged: new TypedSignal<IFulfillmentChangedEvent>(),
        LinkedFulfillmentsChanged: new TypedSignal<IOperatorFulfillment[]>(),
        FulfillmentRemoved: new TypedSignal<IOperatorFulfillment>(),
    },
    views: {
        ShowProduction: new Signal(),
        ShowRoomPlan: new TypedSignal<ShowRoomPlanEventData>(),
        ShowSettings: new Signal(),
        ShowReports: new Signal(),
        ShowItems: new Signal(),
        ShowOpenBills: new Signal(),
        ShowOrders: new Signal(),
        ShowPayments: new Signal(),
    },
    sideMenu: {
        onShow: new TypedSignal<ShowSideMenuEventData>(),
        onHide: new Signal(),
        onChangedSelectedDate: new TypedSignal<SideMenuChangedSelectedDateEventData>(),
    },
    openBillsController: {
        onShown: new Signal(),
        onHidden: new Signal(),
    },
    productionController: {
        onInit: new Signal(),
        onShown: new Signal(),
        onHidden: new Signal(),
        onFulfillmentClick: new TypedSignal<FulfillmentClickedEventData>(),
    },
    roomPlanController: {
        onShown: new TypedSignal<ShowRoomPlanEventData | undefined>(),
        onHidden: new Signal(),
        onRoomPlanLoaded: new TypedSignal<string>(),
    },
    itemsController: {
        onShown: new Signal(),
        onHidden: new Signal(),
    },
    paymentsController: {
        onShown: new Signal(),
        onHidden: new Signal(),
    },
    ordersController: {
        onShown: new Signal(),
        onHidden: new Signal(),
    },
    fulfillmentDetailsPopup: {
        orderNumberSelected: new TypedSignal<string>(),
        showDeliveryAddressClicked: new TypedSignal<string>(),
    },
    orderDetailsModal: {
        openBillTableSelected: new TypedSignal<OpenBillTableSelectedEventData>(),
        showDeliveryAddressClicked: new TypedSignal<string>(),
    },
    transactionDetailsWindow: {
        openBillTableSelected: new TypedSignal<OpenBillTableSelectedEventData>(),
    },
    modals: {
        closeAllModals: new Signal(),
    },
    editPreorderPopup: {
        preorderUpdated: new Signal(),
    },
};
